<ng-container *ngIf="!ssr && translations$ | async as translations">
	<account-bankid_auth
		*ngIf="{ code: qrCode$ | async } as qr"
		auth="registration"
		qrCodeComponentUriProtocol="bankid"
		[images]="images$ | async"
		[pollingTimeout]="pollingTimeout"
		[qrCodeComponentTextQr]="qr.code"
		[qrCodeComponentTranslations]="qrCodeComponentTranslations$ | async"
		[translations]="translations"
		[view]="view"
		[qrCodeComponentView]="qr.code ? 'qr-code' : 'polling'"
		[errorComingFrom]="errorComingFromObservable$ | async"
		[genericLoginError]="error"
		[transactionTimeLeft]="countdownInterval$ | async"
		(bankIdOnAnotherDeviceEvent)="onBankIdOnAnotherDeviceEvent()"
		(bankIdOpenEvent)="onBankIdOpenEvent()"
		(cancelPollingEvent)="onCancelPollingEvent()"
		(notSwedishResidentEvent)="notASwedishResident.emit()"
		(registerAndVerifyLaterEvent)="continueWithoutVerification.emit()"
		(retryBankIdEvent)="onRetryBankIdEvent()"
		(qrCodeCurrentDeviceEvent)="onQrCodeCurrentDeviceEvent()"
		(extendTransactionTimeLeft)="extendTimeLeft()"
	></account-bankid_auth>
</ng-container>
